
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import api from "@/services/api.service";
import AreaDetails from "./AreaDetails.vue";
import AreaDateTimeDisplay from "./AreaDateTimeDisplay.vue";

const SiteMonitor = namespace("siteMonitor");

@Component({
	components: {
		"area-details": AreaDetails,
		"area-date-time-display": AreaDateTimeDisplay,
	}
})
export default class EventDetails extends Vue {
	@SiteMonitor.Getter("getEventDetailsShown") eventDetailsShown!: boolean;
	@SiteMonitor.Mutation setEventDetailsShown: any;

	constructor() {
		super();
	}

	@Prop({ type: String }) siteTitle;
	@Prop({ type: Number }) groupId;

	private timeZoneId: number = null;
	private leaveModal: boolean = false;

	created() {
		this.setEventDetailsShown(false);
	}

	// Immediate: groupId is often already populated before this component is created
	// (siteMonitor.EventDetails is restored from persisted state on a page refresh),
	// so a change-only watch would never resolve the timezone.
	@Watch("groupId", { immediate: true })
	private async setTimeZoneId(newGroupId: number, previousGroupId: number): Promise<void> {
		if (newGroupId === previousGroupId) {
			return;
		}

		// Cleared before the request: the header shows the new area's title as soon as groupId
		// changes, so the previous area's timezone must not stay on the clock while this loads.
		this.timeZoneId = null;

		if (!(newGroupId > 0)) {
			return;
		}

		try {
			const { timeZoneID }: { timeZoneID: number; } = await api.loadGroup(newGroupId);

			// groupId can change again while this is in flight - don't let a stale response
			// overwrite the current area's timezone.
			if (this.groupId !== newGroupId) {
				return;
			}

			this.timeZoneId = timeZoneID;
		}
		catch (e) {
			console.error("Failed to load the area's timezone", e);
		}
	}

	@Watch("eventDetailsShown")
	onEventDetailsShownChanged(value: boolean, oldValue: boolean) {
		if (value) {
			this.leaveModal = true;
		} else {
			this.leaveModal = false
		}
	}

	closeDetails() {
		this.setEventDetailsShown(false);
	}
}
